import React from 'react';
import './FilterOverlay.scss';

const FilterOverlay = (props) => {
  const {
    isOpen,
    title,
    filters,
    dropdownDetails,
    showSearch,
    showDateRange,
    searchPlaceholder,
    onChange,
    onApply,
    onReset,
    onClose,
  } = props;

  if (!isOpen) {
    return null;
  }

  const filterDropdowns = (dropdownDetails || []).filter((item) => item.section !== 'sort');
  const sortDropdowns = (dropdownDetails || []).filter((item) => item.section === 'sort');

  const resolvedSearchPlaceholder = searchPlaceholder || (
    filters.searchBy === 'merchant.name'
      ? 'Enter merchant'
      : filters.searchBy === 'voucher.mobileNo'
        ? 'Enter mobile no'
        : 'Enter redemption ID'
  );

  const renderDropdown = (dropdown) => (
    <div className="filter_overlay_field" key={dropdown.key}>
      <label className="filter_overlay_label" htmlFor={dropdown.key}>
        {dropdown.label}
      </label>
      <select
        id={dropdown.key}
        className="filter_overlay_input"
        value={filters[dropdown.key] || ''}
        onChange={(event) => onChange(dropdown.key, event.target.value)}
      >
        {(dropdown.options || []).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <div className="filter_overlay_backdrop" role="presentation" onClick={onClose}>
      <div
        className="filter_overlay_panel"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="filter_overlay_header">
          <h3>{title}</h3>
          <button type="button" className="filter_overlay_close" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="filter_overlay_body">
          <div className="filter_overlay_section">
            <div className="filter_overlay_section_title">Filters</div>
            <div className="filter_overlay_section_grid">
              {filterDropdowns.map(renderDropdown)}

              {showSearch && (
                <div className="filter_overlay_field filter_overlay_search">
                  <label className="filter_overlay_label" htmlFor="search">
                    Search
                  </label>
                  <input
                    id="search"
                    type="text"
                    className="filter_overlay_input"
                    placeholder={resolvedSearchPlaceholder}
                    value={filters.search || ''}
                    onChange={(event) => onChange('search', event.target.value)}
                  />
                </div>
              )}

              {showDateRange && (
                <>
                  <div className="filter_overlay_field">
                    <label className="filter_overlay_label" htmlFor="fromDate">
                      From Date
                    </label>
                    <input
                      id="fromDate"
                      type="datetime-local"
                      className="filter_overlay_input"
                      value={filters.fromDate || ''}
                      onChange={(event) => onChange('fromDate', event.target.value)}
                    />
                  </div>

                  <div className="filter_overlay_field">
                    <label className="filter_overlay_label" htmlFor="toDate">
                      To Date
                    </label>
                    <input
                      id="toDate"
                      type="datetime-local"
                      className="filter_overlay_input"
                      value={filters.toDate || ''}
                      onChange={(event) => onChange('toDate', event.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {sortDropdowns.length > 0 && (
            <div className="filter_overlay_section">
              <div className="filter_overlay_section_title">Sorting</div>
              <div className="filter_overlay_section_grid">
                {sortDropdowns.map(renderDropdown)}
              </div>
            </div>
          )}
        </div>

        <div className="filter_overlay_actions">
          <button type="button" className="filter_overlay_btn_secondary" onClick={onReset}>
            Reset
          </button>
          <button type="button" className="filter_overlay_btn_primary" onClick={onApply}>
            Apply filters
          </button>
        </div>
      </div>
    </div>
  );
};

FilterOverlay.defaultProps = {
  title: 'Filters',
  filters: {},
  dropdownDetails: [],
  showSearch: true,
  showDateRange: true,
  searchPlaceholder: '',
  onChange: () => {},
  onApply: () => {},
  onReset: () => {},
  onClose: () => {},
};

export default FilterOverlay;